import { useNavigation } from '@react-navigation/native';
import { MainDrawerNavigationProps } from '../MainDrawerNavigator';

/** Oops, typo */
export const useMainDrawerNavigaton = useNavigation<MainDrawerNavigationProps>;
export const useMainDrawerNavigation = useMainDrawerNavigaton;
